module.exports = __webpack_public_path__ + "media/when.c144eaea.ogg";